export default "__VITE_ASSET__EspIejy2__"